document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('[data-gallery-image]').forEach(button=>button.addEventListener('click',()=>{
    const section=button.closest('[data-product-section]');
    const main=section?.querySelector('[data-product-main-image]');
    if(main)main.src=button.dataset.galleryImage;
    section?.querySelectorAll('[data-gallery-image]').forEach(item=>item.classList.toggle('is-selected',item===button));
  }));

  document.querySelectorAll('[data-product-section]').forEach(section=>{
    const total=section.querySelector('[data-bundle-total]');
    const submitPrice=section.querySelector('[data-submit-price]');
    const submit=section.querySelector('[data-product-submit]');
    const form=section.querySelector('[data-product-form]');

    const selectBundle=bundle=>{
      section.querySelectorAll('[data-bundle]').forEach(item=>{
        const selected=item===bundle;
        item.classList.toggle('is-selected',selected);
        item.setAttribute('aria-checked',String(selected));
      });
      const label=`₺${Number(bundle.dataset.displayPrice).toLocaleString('tr-TR')}`;
      if(total)total.textContent=label;
      if(submitPrice)submitPrice.textContent=label;
    };

    section.querySelectorAll('[data-bundle]').forEach(bundle=>{
      bundle.querySelector('[data-bundle-choice]')?.addEventListener('click',()=>selectBundle(bundle));
    });

    form?.addEventListener('submit',async event=>{
      event.preventDefault();
      const selectedBundle=section.querySelector('[data-bundle].is-selected');
      const selectedVariants=[...(selectedBundle?.querySelectorAll('[data-bundle-variant]')||[])].map(select=>Number(select.value));
      if(!selectedVariants.length)return;

      const quantities=new Map();
      selectedVariants.forEach(id=>quantities.set(id,(quantities.get(id)||0)+1));
      const items=[...quantities].map(([id,quantity])=>({id,quantity}));
      const original=submit?.innerHTML;
      if(submit){submit.disabled=true;submit.textContent='Sepete ekleniyor…';}

      try{
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(`${root}cart/add.js`,{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        if(!response.ok)throw new Error('Ürünler sepete eklenemedi.');
        window.location.assign(`${root}cart`);
      }catch(error){
        if(submit){submit.disabled=false;submit.innerHTML=original;}
        window.alert(error.message||'Bir sorun oluştu. Lütfen yeniden deneyin.');
      }
    });

    const ticker=section.querySelector('[data-purchase-ticker]');
    if(ticker){
      const messages=[...ticker.querySelectorAll('span')];
      let active=0;
      window.setInterval(()=>{
        messages[active]?.classList.remove('is-visible');
        active=(active+1)%messages.length;
        messages[active]?.classList.add('is-visible');
      },3200);
    }
  });

  document.querySelectorAll('[data-how-scroll]').forEach(scroller=>{
    const panels=[...scroller.querySelectorAll('[data-how-panel]')];
    const progressItems=[...scroller.querySelectorAll('.product-how-progress i')];
    let active=-1;
    let ticking=false;

    const update=()=>{
      const rect=scroller.getBoundingClientRect();
      const travel=Math.max(1,rect.height-window.innerHeight);
      const progress=Math.min(0.9999,Math.max(0,-rect.top/travel));
      const next=Math.min(panels.length-1,Math.floor(progress*panels.length));
      if(next!==active){
        active=next;
        panels.forEach((panel,index)=>{
          const selected=index===active;
          panel.classList.toggle('is-active',selected);
          panel.setAttribute('aria-hidden',String(!selected));
        });
        progressItems.forEach((item,index)=>item.classList.toggle('is-active',index===active));
      }
      ticking=false;
    };
    const requestUpdate=()=>{
      if(!ticking){ticking=true;window.requestAnimationFrame(update);}
    };
    window.addEventListener('scroll',requestUpdate,{passive:true});
    window.addEventListener('resize',requestUpdate);
    update();
  });
});
